import { useTimelineCondensePellets } from 'app/agriculture/AgTimeline/context/TimelineContext';
import { TimelinePellet, TimelinePelletProps } from './TimelinePellet';
import { PELLET_ROW_HEIGHT, PELLET_ROW_HEIGHT_CONDENSED } from './consts';
import {
    StackingContext,
    useStacking,
} from 'app/agriculture/AgTimeline/components/TimelinePellet/StackingContext/StackingContext';

interface TimelinePelletsProps {
    items: TimelinePelletProps[];
}

export function TimelinePellets({ items }: TimelinePelletsProps) {
    const condensed = useTimelineCondensePellets();
    const stackingContext = useStacking();
    if (items.length === 0) return null;

    return (
        <div
            className="TimelinePellets"
            style={{
                height:
                    stackingContext.rows.length *
                    (condensed ? PELLET_ROW_HEIGHT_CONDENSED : PELLET_ROW_HEIGHT),
            }}
        >
            <StackingContext.Provider value={stackingContext}>
                {items.map((pellet) => (
                    <TimelinePellet key={pellet.id} {...pellet} />
                ))}
            </StackingContext.Provider>
        </div>
    );
}
